<template>
  <img class="riclothes-image" 
    :class="{[`riclothes-image--dark-theme-effect`]: this.$root.config.isDarkTheme}" 
    :style="{[`border-radius`]: radius}" :src="src">
</template>

<script>
export default {
  name: "ri-clothes-image",
  props: {
    src: String,
    radius: {
      radius: String,
      default: "0px"
    }
  }
}
</script>

<style lang="scss" scoped>
.riclothes-image {
  transition: 0.5s;
  &--dark-theme-effect {
    filter: brightness(75%);
  }
}
</style>